import dayjs from 'dayjs'

export const displayTimestamp = timestamp => {

    const now = dayjs()
    const messageTimestamp = dayjs(timestamp instanceof Date ? timestamp : new Date(timestamp))
    const elapsedMs = now.diff(messageTimestamp)

    const messageDay = messageTimestamp.startOf('day')
    const today = now.startOf('day')
    const yesterday = today.subtract(1, 'day')

    // Within the hour
    if (elapsedMs < 1000 * 60 * 60) {
      return messageTimestamp.fromNow()
    }
    // Same calendar day
    if (messageDay.isSame(today, 'day')) {
      return messageTimestamp.format('h:mm a')
    }
    // Previous calendar day
    if (messageDay.isSame(yesterday, 'day')) {
      return messageTimestamp.format('[Yesterday], h:mm a')
    }
    return messageTimestamp.format('MMM D, YYYY h:mm a')
  }
